import { AxiosRequestConfig } from 'axios';

const path = 'admins';

const reportsEndpoints = {
  browseBoxesCsv(
    clientId?: number,
    boxLocationId?: number,
    pageNumber?: number,
    pageSize?: number
  ) {
    return {
      method: 'get',
      url: `${path}/browse-boxes.csv`,
      params: {
        clientId,
        boxLocationId,
        pageNumber,
        pageSize,
      },
      responseType: 'blob',
    } as AxiosRequestConfig;
  },
};

export default reportsEndpoints;
